import { Component, OnInit, NgZone, ViewChild, ElementRef, Output, EventEmitter, OnDestroy, Input, DoCheck, HostListener, AfterViewInit, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { HttpService } from '../../service/http.service';
import{ Router, ActivatedRoute } from '@angular/router';
import { FacebookService, LoginResponse, LoginOptions, UIResponse,
  UIParams, FBVideoComponent } from 'ngx-facebook';
  import { environment } from '../../../environments/environment';
import { eventEmitterService } from '../../service/eventEmitter.service';
import { UserInfoService } from '../../service/user-info.service';
import { HttpClient } from '@angular/common/http';
declare var $: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnDestroy, AfterViewInit{

  login: FormGroup;
  email: {email: any, fb: true};
  isFbook;
  forgotMail;
  error;
  forgot;
  resetSuccessMessages: any;
  loginStatus = false;
  apiUrl = environment.apiUrl;
  userEmail;

  @Output() modalCloseEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Input() modalToOpen: any;
  @Input() errorToNull;

  @ViewChild('modalWindow', { static: false }) modalWindow: ElementRef;
  @ViewChild('modal', { static: false }) modal: ElementRef;

  constructor(private fb: FormBuilder, private _http:HttpService, private http: HttpClient, private route: ActivatedRoute,
              private fbook: FacebookService,private ngZone: NgZone, private router: Router,private renderer: Renderer2,
              private emitter: eventEmitterService, private userInfo: UserInfoService) {
                fbook.init({
                appId: '262874930884852',
                xfbml: true,
                version: 'v5.0',
          });
      }

  ngOnInit() {

    this.login = this.fb.group({
      email: ['', Validators.compose([Validators.required])],
      password: ['', Validators.compose([Validators.required])],
      keepMe : ['']
    });

    var that = this;
    $('#loginForm').on('hidden.bs.modal', function () {
      that.error = '';
      that.errorToNull = '';
      $("#loginForm input#username").val('');
      $("#loginForm input#password").val('');
      that.login.reset();
    });

  }

  ngAfterViewInit(){
    let modalParam = this.route.queryParams;
    this.error = this.route.snapshot.queryParams['error'];
    let deactivatedUser = this.route.snapshot.queryParams['exist'];
    console.log(modalParam, this.error, 'hello')
    if(this.error == "err" && !deactivatedUser){
         //$("#loginForm").modal('show');
         this.error = "Please create your account";
    }else if(this.error == "err" && deactivatedUser){
         //$("#loginForm").modal('show');
         this.error = "Your account has been removed, please contact your administrator";
    }
  }

  userLogin(value, valid){
    ///console.log(value, valid);
    var buildingIds = [];
    if(valid){
      this._http.userLogin(value).subscribe((res)=>{
           if(res){
              console.log(res, "rrrrrr-r-r-r-r-r-r-r-rr-r-r-r-r-r-");
               if(res.success===false){
                this.error = res.message[0];
                this.loginStatus = false;
              }else if(res.token){

                this.userInfo.getUserInfo();

                localStorage.setItem('token', res.token);
                 //console.log('Response: ', res);
                //localStorage.setItem('buildingresidents', res.user)
                this.loginStatus = true;
                for(let building of res.user.building) {
                  buildingIds.push(building.id);
                }
                this.modalCloseEmitter.emit({val1: this.login.valid, val2:this.loginStatus});
                var isManager = (res.user.type === 'manager');
                // Store user's buildingId value(s) to localStorage
                if(!isManager){
                  localStorage.setItem('userBuildingId', res.user.building[0].id);
                }else{
                  localStorage.setItem('userBuildingId', buildingIds.toString());
                }
                $('#modal-wrapper').modal('hide');
                localStorage.setItem('residents', res.user.id);
                sessionStorage.setItem('userId', res.user.id);
                localStorage.setItem('type', res.user.type);
                localStorage.setItem('isManager', isManager.toString());
                localStorage.setItem('maintenance', res.user.isMaintenanceManager);
                if(value.keepMe){
                   localStorage.setItem('keepMe', 'Active');
                }else{
                   localStorage.setItem('keepMe', '');
                }

                this.userInfo.checkForBuildingManager(res.user.id);

                var startDate = new Date();
                var startTime = startDate.getTime().toString();
                localStorage.setItem('activeTime', startTime);
                this.emitter.eventEmit$.next({isHeaderToShow: true});
                setTimeout(() => {
                  // Allows for a force reload to feed
                  window.location.href = '/feed';
                }, 100);

              }
            }
         }

      )}

  }

  @HostListener('document:click', ['$event'])
  public documentClick(event: Event): void {
    var ele = $(event.target)[0].text;
    if(ele && ele === ' Click here'){
      console.log(this.userEmail)
     this._http.resendActivationLink(this.userEmail).subscribe((res)=>{

      if(res){
        this.error = res.message[0];
        setTimeout(() => {
          $('#loginForm').modal('hide');
        }, 5000);
      }
     })
    }
  }

  resetErrors(){
    this.error = null;
  }

  fbpageRedirect(){
     window.location.href= environment.apiUrl+'auth/facebook';
     this.userInfo.getUserInfo();
  }

  logged() {
    this.http.get(environment.apiUrl + 'auth/isLogged', { withCredentials: true }).subscribe(res => console.log(res));

      }

      forgotPassword(){
        console.log(this.forgotMail);
        this._http.resetPassword(this.forgotMail).subscribe(res =>{
          this.resetSuccessMessages = res;
        });
      }
      check(){
        this.http.get(environment.apiUrl+'auth/build').subscribe(res=> console.log(res));
      }



      // modalManage(){
      //   //this.modalCloseEmitter.emit('forgotModal');
      //   $('#loginForm').modal('hide');
      //   this.router.navigate(['building', 'forgotPassword']);
      //   // $('.hide-content').css({display: 'none'});
      //   // $('.toggle-content').css({display: 'block'})
      // }

      modalManage() {
        const modal = document.getElementById('loginForm');
        if (modal) {
            this.renderer.setStyle(modal, 'display', 'none'); // Hide the modal
        }
        this.router.navigate(['building', 'forgotPassword']);
    }
      closeModalWindow(modalWindow){
        var elementId = this.modal.nativeElement.getAttribute('id');
        // $('#'+elementId).hide();
      }

  show(event){
    console.log('hello', event);
  }
  ngOnDestroy(){
    console.log('hello');
    $('.hide-content').css({display: 'block'});
    $('.toggle-content').css({display: 'none'});
    $('#modal-wrapper').modal('hide');
  }

  loginEmitter(){
    this.errorToNull = true;
    //this.modalCloseEmitter.emit({val1: this.login.valid, val2:this.loginStatus});
  }

  closeLoginModal(type){
    if(type =='signUp'){
      $('#loginForm').modal('hide');
      this.emitter.eventEmit$.next({isSignupAlert: true});
      //this.alert = "Please enter your address to proceed with sign up";
    }else{
      //  $('#loginForm').modal('hide');
       //this.alert = null;
       window.location.reload();
    }
}

// Method to hide modal using Renderer2
hideModal() {
    const modal = document.getElementById('loginForm');
    if (modal) {
        this.renderer.setStyle(modal, 'display', 'none');
    }
}

  reloadPage() {
    window.location.reload();
  }

  // gotoLearnMore() {
  //   $('#loginForm').modal('hide');
  //   const el = document.getElementById('learn-more').getBoundingClientRect();
  //   window.scrollTo({
  //     top: el.top,
  //     left: 0,
  //     behavior: 'smooth'
  //   });
  // }

  gotoLearnMore() {
    const modal = document.getElementById('loginForm');
    if (modal) {
      this.renderer.setStyle(modal, 'display', 'none');  // Hide modal
    }
  
    setTimeout(() => {
      const el = document.getElementById('learn-more');
      if (el) {
        const rect = el.getBoundingClientRect();
        window.scrollTo({
          top: rect.top + window.scrollY,
          left: 0,
          behavior: 'smooth'
        });
      }
    }, 300);
  }


}
